import React from "react";

const formatCell = (value) => {
  if (value === null || value === undefined) return "—";
  if (typeof value === "object" && "display_value" in value) {
    return value.display_value ?? "—";
  }
  return String(value);
};

const TableEmbedWidget = ({ widget }) => {
  const rows = Array.isArray(widget.data) ? widget.data : [];
  const columns = rows.length ? Object.keys(rows[0]).filter((k) => k !== "id") : [];

  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden bg-white">
      {widget.title && (
        <div className="px-4 py-2 bg-gray-50 border-b border-gray-200 font-semibold text-sm">
          {widget.title}
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-gray-50">
              {columns.map((col) => (
                <th key={col} className="text-left px-3 py-2 font-medium text-gray-600">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td className="px-3 py-4 text-gray-400" colSpan={columns.length || 1}>
                  No records.
                </td>
              </tr>
            )}
            {rows.map((row, i) => (
              <tr key={row.id || i} className="border-t border-gray-100">
                {columns.map((col) => (
                  <td key={col} className="px-3 py-2">
                    {formatCell(row[col])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableEmbedWidget;
